import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import AOS from 'aos';
import getStore from './store';
import { initialState } from './reducers/form';
import ErrorBoundary from './components/shared/ErrorBoundary';
import API from './utils/api';
import App from './App';
import getLocales, { getDefaults } from './utils/locales';
import './index.css';
import 'aos/dist/aos.css';
import 'react-tabs/style/react-tabs.css';
import GTMService from './utils/gtm';

const api = new API();
const gtm = new GTMService();

window.promocode = '';
window.repEmail = '';
window.refundable = false;

AOS.init({
  disable: true,
  offset: 100,
  duration: 500,
  easing: 'linear',
  delay: 0,
});

const imgorRootContainer = document.getElementById('imgor-root');

// Retrieve data attributes
const overrideApiUrl = imgorRootContainer.dataset['apiUrl'];
const sportDataAttribute = imgorRootContainer.dataset['sport'];
const redirectUrl =
  imgorRootContainer.dataset['redirectUrlShopify'] ||
  process.env.REACT_APP_REDIRECT_URL_SHOPIFY;
const contentPathDataAttribute = imgorRootContainer.dataset['contentPath'];
const businessTypeDataAttribute = imgorRootContainer.dataset['business_type'];
var boardingDataAttribute = imgorRootContainer.dataset['boarding'];
const genderDataAttribute = imgorRootContainer.dataset['gender'];

export const SettingsContext = React.createContext();
export const LocalesContext = React.createContext();

async function mount(data) {

  if (data.apiUrl && data.apiUrl.lastIndexOf("stage") === -1) {
    //console.log = function() {};
  }

  console.log('Mounting React app version:', process.env.REACT_APP_VERSION);
  console.log('Version: 3');

  if (!data || !data.email) {
    //throw new Error('Email is required to init the app');
  }

  window.newitemtag = data.newitemtag;

  if (data.marketing_data) {
    window.marketing_data = data.marketing_data;
  }

  if (data.promocode) {
    window.promocode = data.promocode;
  }

  if (data.repEmail) {
    window.repEmail = data.repEmail;
  }

  if (data.price_type) {
    window.price_type = data.price_type;
  }

  // Override api url if any
  console.log('Check Override API');
  if (overrideApiUrl) {
    api.setUrl(overrideApiUrl);
    console.log('Override API url:', overrideApiUrl);
  }

  if (data.apiUrl) {
    api.setUrl(data.apiUrl);
    console.log('Override API url by data:', data.apiUrl);
  }

  let retargetingData = {};
  if (window.initRetargetingData) {
    retargetingData = window.initRetargetingData();
  }

  if (window.initRetargetingDataCTA) {
    retargetingData = {
      ...retargetingData,
      ...window.initRetargetingDataCTA(),
    };
  }

  let repData = {};
  if (window.initRepData) {
    repData = window.initRepData();
  }

  let locales = getDefaults((data['sport']) ? data['sport'] : sportDataAttribute);
  if (imgorRootContainer.dataset['contentPath']) {
    locales = await getLocales(contentPathDataAttribute, (data['sport']) ? data['sport'] : sportDataAttribute);
  }

  if(boardingDataAttribute === undefined){
    boardingDataAttribute = 'Boarding';
  }

  const settings = {
    email: data['email'],
    redirectUrl: redirectUrl,
    sport: (data['sport']) ? data['sport'] : sportDataAttribute,
    businessType: (data['businessType']) ? data['businessType'] : businessTypeDataAttribute,
    gender: (data['gender']) ? data['gender'] : genderDataAttribute,
    boarding: boardingDataAttribute,
    contentPath: contentPathDataAttribute,
    initialBirthdate: (data['initialBirthdate']) ? data['initialBirthdate'] : '',
  };

  console.log('[index.js] - settings', settings);

  // Preloaded state from storage, coming from an edit action
  let preloadedState = initialState;

  if (window.initStateData) {
    const data = window.initStateData();
    const storage = await api.getStorage(data.id);
    preloadedState = JSON.parse(storage.state.payload);
  } else {
    // Data is coming from Merkato form on Drupal side
    // Only email is required here, we could add other properties too
    preloadedState.camper = {
      ...preloadedState.camper,
      email: data['email'],
      firstName: data['firstName'] || '',
      lastName: data['lastName'] || '',
      phoneNumber: data['phoneNumber'] || '',
    };

    preloadedState.parent = {
      email: data['parentEmail'] || '',
      firstName: data['parentFirstName'] || '',
      lastName: data['parentLastName'] || '',
      phoneNumber: data['parentPhoneNumber'] || '',
      zipcode: data['parentZipcode'] || '',
      country: data['parentCountry'] || '',
    };
  }

  const store = getStore({ form: preloadedState });
  gtm.init(settings, store);

  ReactDOM.render(
    <Provider store={store}>
      <SettingsContext.Provider value={settings}>
        <LocalesContext.Provider value={locales}>
          <ErrorBoundary>
            <App
              retargetingData={{
                boarding: retargetingData['data-retarget-boarding'],
                age: retargetingData['data-retarget-age'],
                gender: retargetingData['data-retarget-gender'],
                date: retargetingData['data-retarget-date'],
                secondaryGroup:
                  retargetingData['data-retarget-secondary_group'],
              }}
              repData={{
                email: repData['rep-email'],
                data: repData['rep-data'],
              }}
            />
          </ErrorBoundary>
        </LocalesContext.Provider>
      </SettingsContext.Provider>
    </Provider>,
    imgorRootContainer
  );
}

if (imgorRootContainer.dataset['external_init'] === 'true') {
  // Mount the app when called in Drupal
  window.initReactApp = (initialData) => {
    mount(initialData);
  };
} else {
  mount({ email: 'stoufa@example.org' });
}
